// Loader.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const Loader = () => {
  const { t } = useTranslation();
  console.log(t("Loading..."));

  return (
    <div className="loader" data-testid="loader-container">
      <div className="container mx-12">
        <div className="circle one" data-testid="circle-one" />
        <div className="circle two" data-testid="circle-two" />
        <div className="circle three" data-testid="circle-three" />
        <span style={{ color: "#372776" }} className="mx-2 mb-5">{t("Loading...")}</span>
      </div>
    </div>
  );
};

export default Loader;
